import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import ICONS from "../../../../assets/Icons";
import StatusContainer from "../../../../components/_utils/CommonStatus/StatusContainer";
import InfoCard from "../../../../components/_utils/CommonStatus/StatusSubComponents/StatusCardContainer/InfoCard";
import TabsWeapperSection from "../../../../components/_utils/CommonStatus/StatusSubComponents/TabsWrapperSection";
import FormatAmount from "../../../../components/_utils/FormatAmount/FormatAmount";
import { setHideBreadCrumb } from "../../../../redux/features/hideBreadCrumb/hideBreadCrumb";

import { GlobalConfiguration } from "../../../../utils/configurationProvider";
import "./index.css";

const TestAuthMatrixOutcomePage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { state } = useLocation();
  const {
    page,
    selectedUser,
    selectedPreviousUsers,
    transaction_auth_matrices,
    predicted_approval,
  } = state || {};

  const status =
    page === "success" ? "success" : page === "error" ? "error" : "pending";

  const [selectedTab, setSelectedTab] = useState("approve");
  const [rulePassedCount, setRulePassedCount] = useState([]);

  const getFullName = (user) =>
    [user?.first_name, user?.last_name].filter(Boolean).join(" ");

  const buttonRows = [
    [
      {
        btnText: "Test new",
        enabledBgColor: "var(--text-primary)",
        enabledTextColor:
          status === "success"
            ? "var(--positive-bg)"
            : status === "error"
              ? "var(--negative-bg)"
              : "var(--neutral-bg)",
        icon: ICONS?.ADD_BUTTON,
        handleFunction: () => {
          navigate("/settings/test_authorization_matrix");
        },
        iconToBeAlign: "left",
        fullWidthRequired: true,
        imgColor:
          status === "success"
            ? "var(--positive-bg)"
            : status === "error"
              ? "var(--negative-bg)"
              : "var(--neutral-bg)",
      },
    ],
    [
      {
        btnText: "Go to dashboard",
        enabledBgColor:
          status === "success"
            ? "var(--positive-bg)"
            : status === "error"
              ? "var(--negative-bg)"
              : "var(--neutral-bg)",
        enabledTextColor: "var(--text-primary)",
        icon: ICONS?.DASHBOARD,
        handleFunction: () => {
          navigate("/settings");
        },
        iconToBeAlign: "left",
        fullWidthRequired: true,
        outLineColor: "var(--text-primary)",
        hoverOption: "dark",
      },
    ],
  ];

  const dynamicAccounts =
    page === "success"
      ? rulePassedCount &&
        rulePassedCount.length > GlobalConfiguration?.lengthCheckZero
        ? rulePassedCount.map((val) => ({
            leftTitle: val?.role,
            leftSubTitle: "Grade",
            rightText: true,
            rightTitle: val?.count,
            rightSubTitle: "Approval/s",
            rightTitleTextColor: "var(--text-primary)",
            rightTextFontWeight: "normal",
          }))
        : []
      : predicted_approval?.predicted_approval_grades &&
          predicted_approval.predicted_approval_grades.length >
            GlobalConfiguration?.lengthCheckZero
        ? predicted_approval.predicted_approval_grades.map((val, index) => ({
            leftTitle: val,
            leftSubTitle: "Grade",
            showBorder:
              predicted_approval.predicted_approval_grades.length -
                GlobalConfiguration?.lengthCheckOne !==
              index,
          }))
        : [];

  useEffect(() => {
    if (!state?.page) {
      navigate("/home", { replace: true });
    }
  }, []);

  useEffect(() => {
    dispatch(setHideBreadCrumb({ hide: true }));
    if (page === "success" && transaction_auth_matrices) {
      const definition = transaction_auth_matrices?.[0]?.definition;

      setRulePassedCount(
        definition.split("<->").map((item) => {
          const [role, count] = item.split("~");
          return {
            role,
            count: Number(count),
          };
        }),
      );
    }
    return () => {
      dispatch(setHideBreadCrumb({ hide: false }));
    };
  }, [dispatch]);

  return (
    <>
      <StatusContainer
        status={status}
        title={
          page === "error"
            ? "Oops! Transaction approval failed."
            : page === "success"
              ? "Transaction has been approved successfully as all the requirements of the rule matches."
              : "Transaction has been approved by the selected user but further approvals are pending."
        }
        subtitle={
          page === "error"
            ? "Transaction approval failed as the selected user is not present in any of the matrix."
            : ""
        }
        buttonRows={buttonRows}
      >
        {page === "error" ? (
          <TabsWeapperSection title="Approved by">
            <>
              <InfoCard
                bgColor={
                  page === "error"
                    ? "var(--negative-card)"
                    : "var(--neutral-card)"
                }
                header={true}
                leftHeaderText="Selected user"
                leftHeaderFontWeight="normal"
                rightHeaderText={getFullName(selectedUser)}
                rightHeaderTextColor="var(--text-secondary)"
                rightHeaderTextSize="var(--font-xs)"
                borderColor={
                  page === "error" ? "var(--negative-bg)" : "var(--neutral-bg)"
                }
                rows={[
                  {
                    leftTitle: selectedUser?.grade,
                    leftSubTitle: "Grade",
                    rightText: true,
                    rightTitle: selectedUser?.user_id,
                    rightSubTitle: "User ID",
                    rightTitleTextColor: "var(--text-primary)",
                    rightTextFontWeight: "normal",
                  },
                ]}
              />

              {selectedPreviousUsers?.map((val, index) => {
                return (
                  <InfoCard
                    bgColor={
                      page === "error"
                        ? "var(--negative-card)"
                        : "var(--neutral-card)"
                    }
                    header={true}
                    leftHeaderText="Previous approver"
                    leftHeaderFontWeight="normal"
                    rightHeaderText={getFullName(val)}
                    rightHeaderTextColor="var(--text-secondary)"
                    rightHeaderTextSize="var(--font-xs)"
                    borderColor={
                      page === "error"
                        ? "var(--negative-bg)"
                        : "var(--neutral-bg)"
                    }
                    rows={[
                      {
                        leftTitle: val?.grade,
                        leftSubTitle: "Grade",
                        rightText: true,
                        rightTitle: val?.user_id,
                        rightSubTitle: "User ID",
                        rightTitleTextColor: "var(--text-primary)",
                        rightTextFontWeight: "normal",
                      },
                    ]}
                  />
                );
              })}
            </>
          </TabsWeapperSection>
        ) : (page === "partial" &&
            !predicted_approval?.predicted_approval_grades &&
            !predicted_approval?.predicted_approval_grades?.length >
              GlobalConfiguration?.lengthCheckZero) ||
          (page === "success" &&
            !rulePassedCount &&
            !rulePassedCount?.length > GlobalConfiguration?.lengthCheckZero) ? (
          <TabsWeapperSection title="Approved by ">
            <>
              <InfoCard
                bgColor={
                  page === "success"
                    ? "var(--positive-card)"
                    : page === "error"
                      ? "var(--negative-card)"
                      : "var(--neutral-card)"
                }
                header={true}
                leftHeaderText="Selected user"
                leftHeaderFontWeight="normal"
                rightHeaderText={getFullName(selectedUser)}
                rightHeaderTextColor="var(--text-secondary)"
                rightHeaderTextSize="var(--font-xs)"
                borderColor={
                  page === "success"
                    ? "var(--positive-bg)"
                    : page === "error"
                      ? "var(--negative-bg)"
                      : "var(--neutral-bg)"
                }
                rows={[
                  {
                    leftTitle: selectedUser?.grade,
                    leftSubTitle: "Grade",
                    rightText: true,
                    rightTitle: selectedUser?.user_id,
                    rightSubTitle: "User ID",
                    rightTitleTextColor: "var(--text-primary)",
                    rightTextFontWeight: "normal",
                  },
                ]}
              />

              {selectedPreviousUsers?.map((val, index) => (
                <InfoCard
                  bgColor={
                    page === "success"
                      ? "var(--positive-card)"
                      : page === "error"
                        ? "var(--negative-card)"
                        : "var(--neutral-card)"
                  }
                  header={true}
                  leftHeaderText="Previous approver"
                  leftHeaderFontWeight="normal"
                  rightHeaderText={getFullName(val)}
                  rightHeaderTextColor="var(--text-secondary)"
                  rightHeaderTextSize="var(--font-xs)"
                  borderColor={
                    page === "success"
                      ? "var(--positive-bg)"
                      : page === "error"
                        ? "var(--negative-bg)"
                        : "var(--neutral-bg)"
                  }
                  rows={[
                    {
                      leftTitle: val?.grade,
                      leftSubTitle: "Grade",
                      rightText: true,
                      rightTitle: val?.user_id,
                      rightSubTitle: "User ID",
                      rightTitleTextColor: "var(--text-primary)",
                      rightTextFontWeight: "normal",
                    },
                  ]}
                />
              ))}
            </>
          </TabsWeapperSection>
        ) : (
          <>
            <TabsWeapperSection title="Approved by">
              {(selectedTab === "approve" && page !== "error") ||
              page === "error" ? (
                <>
                  <InfoCard
                    bgColor={
                      page === "success"
                        ? "var(--positive-card)"
                        : page === "error"
                          ? "var(--negative-card)"
                          : "var(--neutral-card)"
                    }
                    header={true}
                    leftHeaderText="Selected user"
                    leftHeaderFontWeight="normal"
                    rightHeaderText={getFullName(selectedUser)}
                    rightHeaderTextColor="var(--text-secondary)"
                    rightHeaderTextSize="var(--font-xs)"
                    borderColor={
                      page === "success"
                        ? "var(--positive-bg)"
                        : page === "error"
                          ? "var(--negative-bg)"
                          : "var(--neutral-bg)"
                    }
                    rows={[
                      {
                        leftTitle: selectedUser?.grade,
                        leftSubTitle: "Grade",
                        rightText: true,
                        rightTitle: selectedUser?.user_id,
                        rightSubTitle: "User ID",
                        rightTitleTextColor: "var(--text-primary)",
                        rightTextFontWeight: "normal",
                      },
                    ]}
                  />

                  {selectedPreviousUsers?.map((val, index) => (
                    <InfoCard
                      bgColor={
                        page === "success"
                          ? "var(--positive-card)"
                          : page === "error"
                            ? "var(--negative-card)"
                            : "var(--neutral-card)"
                      }
                      header={true}
                      leftHeaderText="Previous approver"
                      leftHeaderFontWeight="normal"
                      rightHeaderText={getFullName(val)}
                      rightHeaderTextColor="var(--text-secondary)"
                      rightHeaderTextSize="var(--font-xs)"
                      borderColor={
                        page === "success"
                          ? "var(--positive-bg)"
                          : page === "error"
                            ? "var(--negative-bg)"
                            : "var(--neutral-bg)"
                      }
                      rows={[
                        {
                          leftTitle: val?.grade,
                          leftSubTitle: "Grade",
                          rightText: true,
                          rightTitle: val?.user_id,
                          rightSubTitle: "User ID",
                          rightTitleTextColor: "var(--text-primary)",
                          rightTextFontWeight: "normal",
                        },
                      ]}
                    />
                  ))}
                </>
              ) : null}
            </TabsWeapperSection>

            <TabsWeapperSection
              title={page === "success" ? "Rule passed" : "Pending approval/s"}
            >
              <>
                <InfoCard
                  bgColor={
                    page === "success"
                      ? "var(--positive-card)"
                      : "var(--neutral-card)"
                  }
                  header={true}
                  leftHeaderText={
                    page === "success"
                      ? "Rule"
                      : "Approvals are pending from individual or all of the following grades."
                  }
                  leftHeaderFontWeight="normal"
                  rightHeaderText={
                    page === "success" ? (
                      <>
                        INR{" "}
                        <FormatAmount
                          price={transaction_auth_matrices?.[0]?.lower_amount}
                        />{" "}
                        - INR{" "}
                        <FormatAmount
                          price={transaction_auth_matrices?.[0]?.higher_amount}
                        />
                      </>
                    ) : (
                      ""
                    )
                  }
                  rightHeaderTextColor="var(--text-secondary)"
                  rightHeaderTextSize="var(--font-xs)"
                  borderColor={
                    page === "success"
                      ? "var(--positive-bg)"
                      : "var(--neutral-bg)"
                  }
                  rows={dynamicAccounts}
                />
              </>
            </TabsWeapperSection>
          </>
        )}
      </StatusContainer>
    </>
  );
};

export default TestAuthMatrixOutcomePage;
